export const ONBOARDING_PLANS = {
	ONE_MONTH_AND_INSTA_GUIDE_19_99_V8: 'getlift_1month_insta_guide_v8',
	ONE_MONTH_19_99_ONE_WEEK_FREE_TRIAL:
		'getlift_1month_19.99USD_1week_auth_void_trial',

	// ---
	ONE_MONTH_9_99: 'getlift_1month_9.99USD_no_trial',
	ONE_MONTH_19_99: 'getlift_1month_19.99USD_no_trial',
	ONE_MONTH_29_99: 'getlift_1month_29.99USD_no_trial',
	THREE_MONTH_49_99: 'getlift_3months_49.99USD_no_trial',
	ONE_WEEK_6_99: 'getlift_1week_6.99USD_no_trial',
	ONE_WEEK_8_99: 'getlift_1week_8.99USD_no_trial',
	THREE_MONTH_39_99: 'getlift_3months_39.99USD_no_trial',
	THREE_MONTH_52_99: 'getlift_3months_52.99USD_no_trial',

	// ---
	TWO_WEEKS_13_99_NO_TRIAL: 'getlift_2weeks_13.99USD_no_trial',
	TWO_WEEKS_19_99_NO_TRIAL: 'getlift_2weeks_19.99USD_no_trial',
	TWO_WEEKS_13_99_TRIAL_ONE_WEEK_1: 'getlift_2weeks_13.99USD_1week_1USD_trial',
	TWO_WEEKS_19_99_TRIAL_ONE_WEEK_1: 'getlift_2weeks_19.99USD_1week_1USD_trial',

	// ---
	ONE_MONTH_AND_INSTA_GUIDE_19_99:
		'getlift_1month_19.99USD_insta_guide_1week_1USD_trial',
	ONE_MONTH_AND_INSTA_GUIDE_29_99:
		'getlift_1month_29.99USD_insta_guide_1week_1USD_trial',

	//
	ONE_MONTH_AND_SMM_CONSULTATION_19_99_AND_49_99:
		'getlift_1month_19.99USD_1month_49.99USD_trial_with_smm_consultation',
	ONE_MONTH_AND_SMM_CONSULTATION_19_99_AND_99_99:
		'getlift_1month_19.99USD_1month_99.99USD_trial_with_smm_consultation',

	// ---
	ONE_MONTH_14_99_ONE_WEEK_1_AND_PROMPTS:
		'getlift_1month_14.99USD_1week_1USD_trial_with_330_chat_gpt_prompts_guide',
	ONE_MONTH_19_99_ONE_WEEK_1_AND_PROMPTS:
		'getlift_1month_19.99USD_1week_1USD_trial_with_330_chat_gpt_prompts_guide',
	ONE_MONTH_MULTI_CURRENCY_19_99_ONE_WEEK_1_AND_PROMPTS:
		'getlift_1month_multi_currency_19.99USD_1week_1USD_trial_with_330_chat_gpt_prompts_guide',
	ONE_MONTH_24_99_ONE_WEEK_1_AND_PROMPTS:
		'getlift_1month_24.99USD_1week_1USD_trial_with_330_chat_gpt_prompts_guide',
	ONE_MONTH_29_99_ONE_WEEK_1_AND_PROMPTS:
		'getlift_1month_29.99USD_1week_1USD_trial_with_330_chat_gpt_prompts_guide',
	ONE_MONTH_MULTI_CURRENCY_29_99_ONE_WEEK_1_AND_PROMPTS:
		'getlift_1month_multi_currency_29.99USD_1week_1USD_trial_with_330_chat_gpt_prompts_guide',
	ONE_MONTH_14_99_TWO_WEEK_1_AND_PROMPTS:
		'getlift_1month_14.99USD_2weeks_1USD_trial_with_330_chat_gpt_prompts_guide',
	ONE_MONTH_19_99_TWO_WEEK_1_AND_PROMPTS:
		'getlift_1month_19.99USD_2weeks_1USD_trial_with_330_chat_gpt_prompts_guide',
	ONE_MONTH_29_99_TWO_WEEK_1_AND_PROMPTS:
		'getlift_1month_29.99USD_2weeks_1USD_trial_with_330_chat_gpt_prompts_guide',

	// --
	ONE_MONTH_19_99_ONE_WEEK_1_WITH_3_GUIDES:
		'getlift_1month_19.99USD_1week_1USD_trial_with_content_planner_guide__instagram_algorithms_guide__50_ideas_for_reels_guide',
	ONE_MONTH_29_99_ONE_WEEK_1_WITH_3_GUIDES:
		'getlift_1month_29.99USD_1week_1USD_trial_with_content_planner_guide__instagram_algorithms_guide__50_ideas_for_reels_guide',

	// ---
	ONE_MONTH_19_99_THREE_DAYS_1: 'getlift_1month_19.99USD_3days_1USD_trial',
	ONE_MONTH_29_99_THREE_DAYS_1: 'getlift_1month_29.99USD_3days_1USD_trial',

	// ---
	ONE_WEEK_5_99_ONE_WEEK_1: 'getlift_1week_5.99USD_1week_1USD_trial',
	ONE_MONTH_9_99_ONE_WEEK_1: 'getlift_1month_9.99USD_1week_1USD_trial',
	ONE_WEEK_11_99_ONE_WEEK_1: 'getlift_1week_11.99USD_1week_1USD_trial',
	ONE_MONTH_14_99_ONE_WEEK_1: 'getlift_1month_14.99USD_1week_1USD_trial',
	ONE_MONTH_19_99_ONE_WEEK_1: 'getlift_1month_19.99USD_1week_1USD_trial',
	ONE_MONTH_19_99_ONE_WEEK_1_PLUS_50_IDEAS_FREE:
		'getlift_1month_19.99USD_1week_1USD_trial_with_50_ideas_for_reels_guide',
	ONE_MONTH_MULTI_CURRENCY_19_99_ONE_WEEK_1:
		'getlift_1month_multi_currency_19.99USD_1week_1USD_trial',
	ONE_MONTH_24_99_ONE_WEEK_1: 'getlift_1month_24.99USD_1week_1USD_trial',
	ONE_MONTH_29_99_ONE_WEEK_1: 'getlift_1month_29.99USD_1week_1USD_trial',
	ONE_MONTH_29_99_ONE_WEEK_1_PLUS_50_IDEAS_FREE:
		'getlift_1month_29.99USD_1week_1USD_trial_with_50_ideas_for_reels_guide',
	ONE_MONTH_MULTI_CURRENCY_29_99_ONE_WEEK_1:
		'getlift_1month_multi_currency_29.99USD_1week_1USD_trial',
	ONE_MONTH_39_99_ONE_WEEK_1: 'getlift_1month_39.99USD_1week_1USD_trial',
	ONE_MONTH_49_99_ONE_WEEK_1: 'getlift_1month_49.99USD_1week_1USD_trial',
	ONE_MONTH_79_99_ONE_WEEK_1: 'getlift_1month_79.99USD_1week_1USD_trial',
	ONE_MONTH_99_99_ONE_WEEK_1: 'getlift_1month_99.99USD_1week_1USD_trial',
	ONE_MONTH_19_99_ONE_WEEK_4_99: 'getlift_1month_19.99USD_1week_4.99USD_trial',
	ONE_MONTH_29_99_ONE_WEEK_4_99: 'getlift_1month_29.99USD_1week_4.99USD_trial',
	ONE_MONTH_29_99_ONE_WEEK_6_99: 'getlift_1month_29.99USD_1week_6.99USD_trial',
	ONE_MONTH_29_99_ONE_WEEK_9: 'getlift_1month_29.99USD_1week_9USD_trial',
	ONE_MONTH_29_99_ONE_MONTH_19_99:
		'getlift_1month_29.99USD_1month_19.99USD_trial',
	THREE_MONTH_49_99_THREE_MONTH_39_99:
		'getlift_3months_49.99USD_3months_39.99USD_trial',

	ONE_MONTH_19_99_ONE_WEEK_5: 'getlift_1month_19.99USD_1week_5USD_trial',
	ONE_MONTH_29_99_ONE_WEEK_5: 'getlift_1month_29.99USD_1week_5USD_trial',
	ONE_MONTH_19_99_ONE_DAY_1: 'getlift_1month_19.99USD_1day_1USD_trial',
	ONE_MONTH_29_99_ONE_DAY_1: 'getlift_1month_29.99USD_1day_1USD_trial',

	// -- TAXES
	ONE_MONTH_MULTI_CURRENCY_19_99_ONE_WEEK_1_VAT_EXCLUDED:
		'getlift_1month_multi_currency_19.99USD_1week_1USD_trial_vat_excluded',
	ONE_MONTH_MULTI_CURRENCY_29_99_ONE_WEEK_1_VAT_EXCLUDED:
		'getlift_1month_multi_currency_29.99USD_1week_1USD_trial_vat_excluded',

	// ---
	ONE_MONTH_24_99_ONE_WEEK_1_EDUCATIONAL_PRODUCTS:
		'getlift_1month_24.99USD_1week_1USD_trial_with_all_educational_products',
	ONE_MONTH_39_99_ONE_WEEK_1_EDUCATIONAL_PRODUCTS:
		'getlift_1month_39.99USD_1week_1USD_trial_with_all_educational_products',

	// ---
	ONE_MONTH_14_99_TWO_WEEK_1: 'getlift_1month_14.99USD_14days_1USD_trial',
	ONE_MONTH_19_99_TWO_WEEK_1: 'getlift_1month_19.99USD_14days_1USD_trial',
	ONE_MONTH_29_99_TWO_WEEK_1: 'getlift_1month_29.99USD_14days_1USD_trial',

	// ---
	ONE_MONTH_29_99_THREE_MONTH_29_99:
		'getlift_1month_29.99USD_3month_29.99USD_trial',
	ONE_MONTH_29_99_THREE_MONTH_49_99:
		'getlift_1month_29.99USD_3month_49.99USD_trial',
	ONE_MONTH_29_99_THREE_MONTH_89_99:
		'getlift_1month_29.99USD_3month_89.99USD_trial',

	// ---
	ONE_MONTH_29_99_SIX_MONTH_69_99:
		'getlift_1month_29.99USD_6month_69.99USD_trial',

	// ---
	ONE_MONTH_29_99_THREE_MONTH_INSTA_GUIDE_29_99:
		'getlift_1month_29.99USD_insta_guide_3month_29.99USD_trial',
	ONE_MONTH_29_99_THREE_MONTH_INSTA_GUIDE_89_99:
		'getlift_1month_29.99USD_insta_guide_3month_89.99USD_trial',

	// ---
	ONE_TIME_50_IDEAS_FOR_REELS_GUIDE_3_99:
		'one_time_getlift_50_ideas_for_reels_guide_3.99USD',
	ONE_TIME_50_IDEAS_FOR_REELS_GUIDE_5_99:
		'one_time_getlift_50_ideas_for_reels_guide_5.99USD',
	ONE_TIME_50_IDEAS_FOR_REELS_GUIDE_19_99:
		'one_time_getlift_50_ideas_for_reels_guide_19.99USD',
	ONE_TIME_50_IDEAS_FOR_REELS_GUIDE_39_99:
		'one_time_getlift_50_ideas_for_reels_guide_39.99USD',
	ONE_TIME_50_IDEAS_FOR_REELS_GUIDE_59_99:
		'one_time_getlift_50_ideas_for_reels_guide_59.99USD',

	// ---
	ONE_TIME_INSTA_GUIDE_9_99: 'one_time_getlift_instagram_guide_9.99USD',
	ONE_TIME_INSTA_GUIDE_19_99: 'one_time_getlift_instagram_guide_19.99USD',
	ONE_TIME_INSTA_GUIDE_MULTI_CURRENCY_19_99:
		'one_time_getlift_instagram_guide_multi_currency_19.99USD',
	ONE_TIME_INSTA_GUIDE_29_99: 'one_time_getlift_instagram_guide_29.99USD',
	ONE_TIME_INSTA_GUIDE_49_99: 'one_time_getlift_instagram_guide_49.99USD',
	ONE_TIME_INSTA_GUIDE_MULTI_CURRENCY_49_99:
		'one_time_getlift_instagram_guide_multi_currency_49.99USD',
	ONE_TIME_INSTA_GUIDE_100: 'one_time_getlift_instagram_guide_100.00USD',
	ONE_TIME_INSTA_GUIDE_194_92: 'one_time_getlift_instagram_guide_194.92USD',
	ONE_TIME_INSTA_GUIDE_MULTI_CURRENCY_194_92:
		'one_time_getlift_instagram_guide_multi_currency_194.92USD',

	ONE_TIME_ULTIMATE_BUNDLE_49_99:
		'one_time_getlift_lift_ultimate_bundle_49.99USD',
	ONE_TIME_ULTIMATE_BUNDLE_99_99:
		'one_time_getlift_lift_ultimate_bundle_99.99USD',

	// ---
	SIX_MOTH_44_99USD_SEVEN_DAYS_1USD_INSTAGRAM_ALGORITHMS_GUIDE:
		'getlift_6month_44.99USD_7days_1USD_trial_with_instagram_algorithms_guide',
	SIX_MOTH_44_99USD_SEVEN_DAYS_1USD_REELS_IDEAS_GUIDE:
		'getlift_6month_44.99USD_7days_1USD_trial_with_50_ideas_for_reels_guide',
	SIX_MOTH_44_99USD_SEVEN_DAYS_1USD_CONTENT_PLANNER_GUIDE:
		'getlift_6month_44.99USD_7days_1USD_trial_with_content_planner_guide',

	// ---
	ONE_TIME_THREADS_GUIDE_9_99: 'one_time_getlift_threads_guide_9.99USD',
	ONE_TIME_THREADS_GUIDE_6_99: 'one_time_getlift_threads_guide_6.99USD',

	// ---
	ONE_TIME_INSTA_ADVERTISING_GUIDE_7_99:
		'one_time_getlift_instagram_advertising_guide_7.99USD',
	ONE_TIME_INSTA_ADVERTISING_GUIDE_9_99:
		'one_time_getlift_instagram_advertising_guide_9.99USD',
	ONE_TIME_INSTA_ADVERTISING_GUIDE_15_99:
		'one_time_getlift_instagram_advertising_guide_15.99USD',
	ONE_TIME_INSTA_ADVERTISING_GUIDE_17_50:
		'one_time_getlift_instagram_advertising_guide_17.50USD',
	ONE_TIME_INSTA_ADVERTISING_GUIDE_MULTI_CURRENCY_17_50:
		'one_time_getlift_instagram_advertising_guide_multi_currency_17.50USD',
	ONE_TIME_INSTA_ADVERTISING_GUIDE_34_99:
		'one_time_getlift_instagram_advertising_guide_34.99USD',
	ONE_TIME_INSTA_ADVERTISING_GUIDE_17_99:
		'one_time_getlift_instagram_advertising_guide_17.99USD',
	ONE_TIME_INSTA_ADVERTISING_GUIDE_MULTI_CURRENCY_34_99:
		'one_time_getlift_instagram_advertising_guide_multi_currency_34.99USD',

	// ---
	ONE_TIME_BRAND_POSITIONING_GUIDE_5_99:
		'one_time_getlift_brand_positioning_guide_5.99USD',
	ONE_TIME_BRAND_POSITIONING_GUIDE_9_99:
		'one_time_getlift_brand_positioning_guide_9.99USD',
	ONE_TIME_BRAND_POSITIONING_GUIDE_11_99:
		'one_time_getlift_brand_positioning_guide_11.99USD',
	ONE_TIME_BRAND_POSITIONING_GUIDE_19_99:
		'one_time_getlift_brand_positioning_guide_19.99USD',
	ONE_TIME_BRAND_POSITIONING_GUIDE_MULTI_CURRENCY_19_99:
		'one_time_getlift_brand_positioning_guide_multi_currency_19.99USD',
	ONE_TIME_BRAND_POSITIONING_GUIDE_59_99:
		'one_time_getlift_brand_positioning_guide_59.99USD',
	ONE_TIME_BRAND_POSITIONING_GUIDE_MULTI_CURRENCY_59_99:
		'one_time_getlift_brand_positioning_guide_multi_currency_59.99USD',

	// ---
	THREE_MONTH_49_99_ONE_WEEK_1: 'getlift_3months_49.99USD_1week_1USD_trial',
	SIX_MONTH_69_99_TWO_WEEKS_1: 'getlift_6months_69.99USD_2weeks_1USD_trial',

	// ---
	ONE_TIME_ALL_EDUCATIONAL_9_99:
		'getlift_all_educational_products_1month_9.99USD_no_trial',
	ONE_TIME_ALL_EDUCATIONAL_19_99:
		'getlift_all_educational_products_1month_19.99USD_no_trial',

	// ---
	ONE_TIME_TIKTOK_GUIDE_9_99: 'one_time_getlift_tik_tok_guide_9.99USD',
	ONE_TIME_TIKTOK_GUIDE_19_99: 'one_time_getlift_tik_tok_guide_19.99USD',
	ONE_TIME_TIKTOK_GUIDE_39_99: 'one_time_getlift_tik_tok_guide_39.99USD',
	ONE_TIME_TIKTOK_GUIDE_34_99: 'one_time_getlift_tik_tok_guide_34.99USD',
	ONE_TIME_TIKTOK_GUIDE_17_99: 'one_time_getlift_tik_tok_guide_17.99USD',

	// ---
	ONE_TIME_ALL_IN_ONE_GUIDES_V1_289_99:
		'one_time_getlift_instagram__50_ideas_for_reels__tik_tok_guides_289.99USD',
	ONE_TIME_ALL_IN_ONE_GUIDES_V1_29_99:
		'one_time_getlift_instagram__50_ideas_for_reels__tik_tok_guides_29.99USD',
	ONE_TIME_ALL_IN_ONE_GUIDES_V2_289_99:
		'one_time_getlift_instagram__brand_positioning__instagram_advertising_guides_289.99USD',
	ONE_TIME_ALL_IN_ONE_GUIDES_V2_29_99:
		'one_time_getlift_instagram__brand_positioning__instagram_advertising_guides_29.99USD',

	// ---
	ONE_TIME_SMM_CONSULTATION_CONTENT_PLAN_50_00:
		'one_time_getlift_smm_consultation_content_plan_50.00USD',
	ONE_TIME_SMM_CONSULTATION_GROWTH_CHECKLIST_50_00:
		'one_time_getlift_smm_consultation_growth_checklist_50.00USD',
	ONE_TIME_SMM_CONSULTATION_SOCIAL_MEDIA_REVIEW_50_00:
		'one_time_getlift_smm_consultation_social_media_review_50.00USD',

	// --
	ONE_TIME_ACCESS_REEL_GUIDE_PLAN_9_99: 'one_time_getlift_reels_guide_9.99USD',
	ONE_TIME_ACCESS_REEL_GUIDE_PLAN_19_99:
		'one_time_getlift_reels_guide_19.99USD',

	ONE_TIME_50_REEL_IDEAS_GUIDE_PLAN_9_99:
		'one_time_getlift_50_ideas_for_reels_guide_9.99USD',
	ONE_TIME_50_REEL_IDEAS_GUIDE_PLAN_19_99:
		'one_time_getlift_50_ideas_for_reels_guide_19.99USD',

	ONE_TIME_CONTENT_PLANNER_PLAN_9_99:
		'one_time_getlift_content_planner_guide_9.99USD',
	ONE_TIME_CONTENT_PLANNER_PLAN_19_99:
		'one_time_getlift_content_planner_guide_19.99USD',

	ONE_TIME_INSTAGRAM_ALGORITHM_PLAN_9_99:
		'one_time_getlift_instagram_algorithms_guide_9.99USD',
	ONE_TIME_INSTAGRAM_ALGORITHM_PLAN_19_99:
		'one_time_getlift_instagram_algorithms_guide_19.99USD',

	// ---
	ONE_MONTH_30_99_NO_TRIAL: 'getlift_1month_30.99USD_no_trial',
	ONE_MONTH_14_99_NO_TRIAL: 'getlift_1month_14.99USD_no_trial',
	ONE_MONTH_11_99_NO_TRIAL: 'getlift_1month_11.99USD_no_trial',

	THREE_MONTH_62_99_NO_TRIAL: 'getlift_3months_62.99USD_no_trial',
	THREE_MONTH_24_99_NO_TRIAL: 'getlift_3months_24.99USD_no_trial',
	THREE_MONTH_18_99_NO_TRIAL: 'getlift_3months_18.99USD_no_trial',

	TWELVE_MONTH_169_99_NO_TRIAL: 'getlift_1year_169.99USD_no_trial',
	TWELVE_MONTH_84_99_NO_TRIAL: 'getlift_1year_84.99USD_no_trial',
	TWELVE_MONTH_67_99_NO_TRIAL: 'getlift_1year_67.99USD_no_trial',

	ONE_MONTH_30_99_ONE_MONTH_14_99:
		'getlift_1month_30.99USD_1month_14.99USD_trial',
	THREE_MONTH_62_99_THREE_MONTH_24_99:
		'getlift_3months_62.99USD_3months_24.99USD_trial',
	TWELVE_MONTH_169_99_TWELVE_MONTH_84_99:
		'getlift_1year_169.99USD_1year_84.99USD_trial',
	ONE_MONTH_30_99_ONE_MONTH_11_99:
		'getlift_1month_30.99USD_1month_11.99USD_trial',
	THREE_MONTH_62_99_THREE_MONTH_18_99:
		'getlift_3months_62.99USD_3months_18.99USD_trial',
	TWELVE_MONTH_169_99_TWELVE_MONTH_67_99:
		'getlift_1year_169.99USD_1year_67.99USD_trial',

	// ---ES---
	ES_ONE_MONTH_30_99_ONE_MONTH_14_99:
		'getlift_es_1month_30.99USD_1month_14.99USD_trial',
	ES_ONE_MONTH_30_99_NO_TRIAL: 'getlift_es_1month_30.99USD_no_trial',
	ES_ONE_MONTH_30_99_ONE_MONTH_11_99:
		'getlift_es_1month_30.99USD_1month_11.99USD_trial',

	ES_THREE_MONTH_62_99_THREE_MONTH_24_99:
		'getlift_es_3months_62.99USD_3months_24.99USD_trial',
	ES_THREE_MONTH_62_99_NO_TRIAL: 'getlift_es_3months_62.99USD_no_trial',
	ES_THREE_MONTH_62_99_THREE_MONTH_18_99:
		'getlift_es_3months_62.99USD_3months_18.99USD_trial',

	ES_TWELVE_MONTH_169_99_TWELVE_MONTH_84_99:
		'getlift_es_1year_169.99USD_1year_84.99USD_trial',
	ES_TWELVE_MONTH_169_99_NO_TRIAL: 'getlift_es_1year_169.99USD_no_trial',
	ES_TWELVE_MONTH_169_99_TWELVE_MONTH_67_99:
		'getlift_es_1year_169.99USD_1year_67.99USD_trial',

	// ES UPSELLS
	ES_ONE_TIME_INSTA_GUIDE_MULTI_CURRENCY_49_99:
		'one_time_getlift_es_instagram_guide_49.99USD',
	ES_ONE_TIME_INSTA_GUIDE_MULTI_CURRENCY_194_92:
		'one_time_getlift_es_instagram_guide_194.92USD',
	ES_ONE_TIME_INSTA_GUIDE_MULTI_CURRENCY_19_99:
		'one_time_getlift_es_instagram_guide_19.99USD',

	ES_ONE_TIME_INSTA_ADVERTISING_GUIDE_MULTI_CURRENCY_17_50:
		'one_time_getlift_es_instagram_advertising_guide_17.50USD',
	ES_ONE_TIME_INSTA_ADVERTISING_GUIDE_MULTI_CURRENCY_34_99:
		'one_time_getlift_es_instagram_advertising_guide_34.99USD',

	ES_ONE_TIME_BRAND_POSITIONING_GUIDE_MULTI_CURRENCY_19_99:
		'one_time_getlift_es_brand_positioning_guide_19.99USD',
	ES_ONE_TIME_BRAND_POSITIONING_GUIDE_MULTI_CURRENCY_59_99:
		'one_time_getlift_es_brand_positioning_guide_59.99USD',

	// -- PT
	PT_ONE_MONTH_19_99_ONE_WEEK_1:
		'getlift_br_mx_pe_1month_19.99USD_1week_1USD_trial',
	PT_ONE_MONTH_29_99_ONE_WEEK_1:
		'getlift_br_mx_pe_1month_29.99USD_1week_1USD_trial',

	// AR
	AR_ONE_MONTH_MULTI_CURRENCY_19_99_ONE_WEEK_1_VAT_INCLUDED:
		'getlift_1month_multi_currency_arabic_19.99USD_1week_1USD_trial_vat_included',
	AR_ONE_MONTH_MULTI_CURRENCY_29_99_ONE_WEEK_1_VAT_INCLUDED:
		'getlift_1month_multi_currency_arabic_29.99USD_1week_1USD_trial_vat_included',

	// -- ES --
	ES_ONE_MONTH_19_99_ONE_WEEK_1:
		'getlift_1month_multi_currency_latam_es_19.99USD_1week_1USD_trial_vat_included',
	ES_ONE_MONTH_29_99_ONE_WEEK_1:
		'getlift_1month_multi_currency_latam_es_29.99USD_1week_1USD_trial_vat_included',
};
